import { onClassChange } from '../common/observers';

(() => {
    const $siteHeader = document.querySelector('.site-header');
    const $block = document.querySelector('.block');
    const $parentSubMenuWraps = document.querySelectorAll('.site-menu-bar > .site-menu > .menu-item-has-children');

    let lastScrollPos = window.scrollY;

    const initSiteHeaderBackground = () => {
        if (!$siteHeader) return;

        if (window.scrollY <= $siteHeader.clientHeight) {
            $siteHeader.classList.remove('site-header--scrolled');
        } else {
            $siteHeader.classList.add('site-header--scrolled');
        }
    };

    const toggleSiteHeader = () => {
        if (window.scrollY > lastScrollPos && window.scrollY > 100) {
            $siteHeader.classList.add('site-header--hide');

            $parentSubMenuWraps?.forEach($parentSubMenuWrap => {
                const $subMenuToggle = $parentSubMenuWrap.querySelector('a');

                $parentSubMenuWrap.classList.remove('menu-item--active');
                $subMenuToggle.setAttribute('aria-expanded', 'false');
            });

            lastScrollPos = window.scrollY;
        };
        
        if (window.scrollY <= 100 || window.scrollY < lastScrollPos - 100) {
            $siteHeader.classList.remove('site-header--hide');

            lastScrollPos = window.scrollY;
        };
    };

    onClassChange($block, (observer) => {
        const darkBlockClasses = [
            'background-color-black',
            'background-color-forest',
            'background-color-purple',
        ];

        const lightBlockClasses = [
            'background-color-white',
            'background-color-mauve',
            'background-color-sage',
            'background-color-red',
            'background-color-pink',
            'background-color-cream',
            'background-color-yellow',
        ];

        darkBlockClasses.forEach(blockClass => {
            if ($block.classList.contains(blockClass)) {
                $siteHeader.classList.add('site-header--white');
            }
        });

        lightBlockClasses.forEach(blockClass => {
            if ($block.classList.contains(blockClass)) {
                $siteHeader.classList.remove('site-header--white');
            }
        });
    });

    window.addEventListener('scroll', () => {
        initSiteHeaderBackground();
        toggleSiteHeader();
    });

    initSiteHeaderBackground();
})();
